export default function formatTime(durationInSeconds) {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = durationInSeconds % 60;

  // Chỉ hiển thị phút và giây nếu không có giờ
  return hours > 0 ? `${hours} giờ ${minutes} phút ${seconds} giây` : `${minutes} phút ${seconds} giây`;
}
